import type { ConnectionStrategy } from '../../../core/ports/preferences-repository';
import { useLocale } from '../i18n/LocaleProvider';

export function ConnectionStrategySwitcher({ connectionStrategy, onChange }: { connectionStrategy: ConnectionStrategy; onChange: (connectionStrategy: ConnectionStrategy) => void }) {
	const { t } = useLocale();

	return (
		<label style={{ display: 'grid', gap: 6 }}>
			<span>{t('connectionStrategy')}</span>
			<select
				className="hud-input"
				aria-label={t('connectionStrategy')}
				value={connectionStrategy}
				onChange={(event) => onChange(event.target.value as ConnectionStrategy)}
			>
				<option value="relation-first">{t('connectionStrategyRelationFirst')}</option>
				<option value="balanced">{t('connectionStrategyBalanced')}</option>
				<option value="label-first">{t('connectionStrategyLabelFirst')}</option>
			</select>
		</label>
	);
}